(function () {
  if (document.documentElement.dataset.zenShopTheLookLoaded === 'true') return;

  document.documentElement.dataset.zenShopTheLookLoaded = 'true';

  var sectionSelector = '[data-zen-shop-the-look]';

  function getSections(container) {
    var root = container || document;
    var sections = [];

    if (root.matches && root.matches(sectionSelector)) sections.push(root);

    return sections.concat(Array.prototype.slice.call(root.querySelectorAll(sectionSelector)));
  }

  function getOpenCards(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-zen-look-card].is-open'));
  }

  function closeCard(card) {
    var trigger = card.querySelector('[data-zen-look-trigger]');
    var panel = card.querySelector('[data-zen-look-panel]');

    card.classList.remove('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (panel) {
      panel.hidden = true;
    }
  }

  function closeAll(section, exceptCard) {
    getOpenCards(section).forEach(function (card) {
      if (card !== exceptCard) closeCard(card);
    });
  }

  function openCard(section, card) {
    var trigger = card.querySelector('[data-zen-look-trigger]');
    var panel = card.querySelector('[data-zen-look-panel]');

    closeAll(section, card);
    card.classList.add('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    if (panel) {
      panel.hidden = false;
    }
  }

  function toggleCard(section, card) {
    if (card.classList.contains('is-open')) {
      closeCard(card);
      return;
    }

    openCard(section, card);
  }

  function destroySection(section) {
    if (typeof section.zenShopTheLookCleanup === 'function') {
      section.zenShopTheLookCleanup();
    }
  }

  function initializeSection(section) {
    if (section.dataset.zenShopTheLookInitialized === 'true') return;

    function onSectionClick(event) {
      var trigger = event.target.closest('[data-zen-look-trigger]');
      var close = event.target.closest('[data-zen-look-close]');

      if (trigger && section.contains(trigger)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCard(section, trigger.closest('[data-zen-look-card]'));
        return;
      }

      if (close && section.contains(close)) {
        event.preventDefault();
        event.stopPropagation();
        closeCard(close.closest('[data-zen-look-card]'));
        return;
      }

      if (!event.target.closest('[data-zen-look-card]')) {
        closeAll(section);
      }
    }

    function onDocumentClick(event) {
      if (!section.contains(event.target)) {
        closeAll(section);
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeAll(section);
      }
    }

    section.addEventListener('click', onSectionClick);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);

    section.dataset.zenShopTheLookInitialized = 'true';
    section.zenShopTheLookCleanup = function () {
      section.removeEventListener('click', onSectionClick);
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onKeydown);
      delete section.dataset.zenShopTheLookInitialized;
      delete section.zenShopTheLookCleanup;
    };
  }

  function initializeSections(container) {
    getSections(container).forEach(initializeSection);
  }

  function destroySections(container) {
    getSections(container).forEach(destroySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSections(document);
    });
  } else {
    initializeSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
